module.exports = __webpack_public_path__ + "static/media/WarningExpired.a6a60f7d.png";